var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDashboardActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.094,
    height: 22.669,
    viewBox: "0 0 31.094 22.669",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico-dashboard-active",
    transform: "translate(0.5 -7.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M28.891,23.649h-1.2V10.408A2.408,2.408,0,0,0,25.279,8H23.474a1.2,1.2,0,1,0,0,2.408h1.806V23.649H4.815V10.408h12.64a1.2,1.2,0,0,0,0-2.408H4.815a2.408,2.408,0,0,0-2.408,2.408V23.649H1.2a1.2,1.2,0,0,0-1.2,1.2V27.26a2.468,2.468,0,0,0,2.516,2.408H27.579a2.468,2.468,0,0,0,2.516-2.408V24.853A1.2,1.2,0,0,0,28.891,23.649ZM27.579,27.26H2.516a.65.65,0,0,1-.108,0h0v-1.2H27.687v1.162A.15.15,0,0,1,27.579,27.26Z",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M26.815,25.63a4.815,4.815,0,1,0,0-9.63,1.2,1.2,0,1,0,0,2.408,2.408,2.408,0,1,1-2.408,2.408,1.2,1.2,0,1,0-2.408,0,4.815,4.815,0,0,0,4.815,4.815Z",
    transform: "translate(-8.758 -3.185)",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M18.782,19.256a1.2,1.2,0,0,0,1.7-1.7l-1.2-1.2A1.2,1.2,0,0,0,18.426,16H11.2a1.2,1.2,0,0,0,0,2.408h6.723Z",
    transform: "translate(-3.981 -3.185)",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M11.2,24.408h2.408a1.2,1.2,0,1,0,0-2.408H11.2a1.2,1.2,0,1,0,0,2.408Z",
    transform: "translate(-3.981 -5.574)",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M11.2,30.408h3.611a1.2,1.2,0,0,0,0-2.408H11.2a1.2,1.2,0,1,0,0,2.408Z",
    transform: "translate(-3.981 -7.962)",
    stroke: "#fff",
    strokeWidth: 1
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardActive);
export default __webpack_public_path__ + "static/media/dashboardActive.f68043c3fc8d457ced607766fcf8cd02.svg";
export { ForwardRef as ReactComponent };